// extracted by mini-css-extract-plugin
export default {"container":"LegendItem_container__IzjoX","color_box_frame":"LegendItem_color_box_frame__tR-kf","color_box":"LegendItem_color_box__ORXwj","text":"LegendItem_text__yuovR"};